import {lazy} from 'react';
import {BookingMapping} from './Constant';

const BookingRouterView = lazy(() => import('./view/BookingRouterView'));

export default [
    {id: BookingMapping.bookingRouter, exact: true, component: BookingRouterView},
];